import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import createPlugins from '../plugins';

export default (store) => {
  store.registerModule(
    ['requests', 'history', 'types'],
    new BaseModule({
      makeQueryParams: makeListRequest({}),
      searchAttributesArray: ['name'],
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/properties/${id}/work_order_group_types`,
    })
  );

  createPlugins({
    module: 'requests/history/types',
    store,
  });
};
